/*eslint-disable */
import Vue from 'vue'
var $ = window.jQuery = require('jquery');
import toast from '@/services/toast';
import {
  bus
} from '@/main';
export default {
  name: 'create-product',
  components: {
  },
  props: [],
  data () {
    return {
      selfUserId:'',
      name:'',
      description:'',
      submitted:false
    }
  },
  computed: {
  },
  mounted () {
    if(localStorage.getItem('LoginedUserID')){
      this.selfUserId = localStorage.getItem('LoginedUserID')
    }
  },
  methods: {
    closeCreateSubscriptioProductPopup(){
      bus.$emit('createSubscriptionProductStateBus', false)
      document.body.classList.remove('body_right_scroll_remove')
    },
    createSubscriptionProductBeforeSubmitMethod(){
      this.$validator.validateAll().then((result) => {
        if(result){
          this.submitted =  true
          let data = {
            name:this.name,
            description:this.description,
            type: 'DIGITAL',
            category: 'HOSPITALS'
          }
          this.$store.dispatch('createSubscriptionProductInfoFunc', data).then((res) => {  
            toast.success('Subscription product is created successfully');
            this.submitted =  false
            this.$store.dispatch('getSubscriptionProductListFunc');
            this.closeCreateSubscriptioProductPopup();
          }).catch((err) => {
            toast.error('Request is failed');
            this.submitted =  false
          })
        return;
        }
      })
    }
  },
  watch: {
  },
}